import * as React from 'react';
import ScriptComponent from '../classroomLessons/shared/scriptComponent';
import { getComponent } from './helpers';

export default class Slide extends React.Component<any, any> {
  constructor(props) {
    super(props)

    this.state = {
      showSlide: true,
      showScript: false
    }

    this.toggleShowScript = this.toggleShowScript.bind(this)
    this.toggleShowSlide = this.toggleShowSlide.bind(this)
  }

  componentDidUpdate(prevProps) {
    const { incompletePrompt } = this.props
    if (incompletePrompt && !prevProps.incompletePrompt) {
      this.setState({showSlide: true})
    }
  }

  toggleShowSlide() {
    this.setState({showSlide: !this.state.showSlide})
  }

  toggleShowScript() {
    this.setState({showScript: !this.state.showScript})
  }

  slideTypeName() {
    switch (this.props.question.type) {
      case 'CL-ST':
      case 'CL-EX':
        return 'Static Text'
      case 'CL-MD':
        return 'Teacher Model'
      case 'CL-SA':
      case 'CL-FB':
      case 'CL-FL':
      case 'CL-MS':
        return 'Students Practice'
      default:
        return ''
    }
  }

  renderSlide() {
    if (this.state.showSlide) {
      const Component = getComponent(this.props.question.type)
      const showScriptButtonText = this.state.showScript ? 'Hide Step-By-Step Guide' : 'Show Step-By-Step Guide'
      return (
        <div className="slide-body">
          <Component
            clearSlide={this.props.clearSlide}
            incompletePrompt={this.props.incompletePrompt}
            question={this.props.question.data}
            questionIndex={this.props.questionIndex}
            resetSlide={this.props.resetSlide}
            updateQuestion={this.props.updateQuestion}
          />
          <button className="quill-button small outlined grey focus-on-light show-guide-button" onClick={this.toggleShowScript} type="button">
            {showScriptButtonText}
          </button>
          {this.renderScript()}
        </div>
      )
    }
  }

  renderScript() {
    if (this.state.showScript) {
      const filteredScript = this.props.question.data.teach.script.filter(s => s.type === 'STEP-HTML' || s.type === 'STEP-HTML-TIP')
      return (
        <div className="script">
          <ScriptComponent script={filteredScript} />
        </div>
      )
    }
  }

  render() {
    const { questionIndex, } = this.props
    const slideId = `slide-${questionIndex}`

    const showSlideButtonText = this.state.showSlide ? 'Hide' : 'Show'
    return (
      <section aria-labelledby={slideId} className="slide-container" key={questionIndex}>
        <div className='slide-header'>
          <h2 className='slide-number-and-type' id={slideId}>
            <span className="slide-number">Slide {questionIndex}</span>
            <span className="slide-divider" />
            <span className="slide-type">{this.slideTypeName()}</span>
          </h2>
          <button className="quill-button small outlined green focus-on-light" onClick={this.toggleShowSlide} type="button">{showSlideButtonText}</button>
        </div>
        {this.renderSlide()}
      </section>
    )
  }
}
